import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreatePricingCategoryDto, UpdatePricingCategoryDto } from '../dtos/pricing-category/pricingCategoryDto';

@Injectable({
  providedIn: 'root'
})
export class PricingCategoryService {

  private apiUrl = `${environment.apiUrl}/pricingcategories`;

  constructor(private http: HttpClient) {}

  getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  create(entity: CreatePricingCategoryDto): Observable<any> {
    return this.http.post(`${this.apiUrl}`, entity);
  }

  update(id: number, entity: UpdatePricingCategoryDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, entity);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
